import MuiDivider from '@material-ui/core/Divider';

const Divider = (props) => <MuiDivider { ...props } />;

export default Divider;
